"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var styled_1 = __importDefault(require("@emotion/styled")); // Documentation: https://serratus.github.io/quaggaJS/
// This is the same library that Ryerson.com 2.0 was using.
// @ts-ignore


var quagga_1 = __importDefault(require("quagga"));

var BarcodeScannerLayout = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t.drawingBuffer {\n\t\tdisplay: none;\n\t}\n\n\t#barcode-scanner-view {\n\t\taspect-ratio: 2 / 1;\n\t\toverflow: hidden;\n\t}\n\n\tvideo {\n\t\twidth: 100% !important;\n\t\theight: 100% !important;\n\t\tobject-fit: cover;\n\t}\n"])));

var BarcodeScanner = function BarcodeScanner(_ref) {
  var onBarcode = _ref.onBarcode,
      onError = _ref.onError;
  (0, react_1.useEffect)(function () {
    quagga_1.default.onDetected(function (data) {
      onBarcode(data.codeResult.code);
    });
    quagga_1.default.init({
      inputStream: {
        name: "Live",
        type: "LiveStream",
        constraints: {
          width: 1200,
          // Setting larger so it scales okay
          height: 600,
          facingMode: "environment"
        },
        target: "#barcode-scanner-view"
      },
      decoder: {
        readers: ["code_39_reader"] // code_39 aka code 3 of 9

      },
      locator: {
        patchSize: "small" // x-small, small, medium, large, x-large

      }
    }, function (err) {
      if (err) {
        onError(err);
        return;
      }

      quagga_1.default.start();
    });
    return function () {
      quagga_1.default.stop();
    };
  }, []);
  return (0, jsx_runtime_1.jsx)(BarcodeScannerLayout, {
    children: (0, jsx_runtime_1.jsx)("div", {
      id: "barcode-scanner-view"
    })
  });
};

exports.default = BarcodeScanner;